import { activateEmailApi } from './activateEmailApi';

export const { useEmailActivateMutation } = activateEmailApi;

export { activateEmailApi };
